import api from './index';
//
let exports = {};

// 查询商品标识码
exports.checkMerchtSbfjUknoByItems = function (params, callback) {// 查询商品标识码
    api.post('/retailer/door/mercht/sbfj/ukno/check/by/itemIds')
    .data(params)
    .done(callback)
    .go();
};

// 查询商品标识码
exports.getMerchtSbfjUknoListByFilter = function (params, callback) {// 查询商品标识码
    api.post('/retailer/door/mercht/sbfj/ukno/list/get/by/filter')
    .data(params)
    .done(callback)
    .go();
};
//
// ====================== 供商编码 ===========================

// 查询所有供商编码
exports.getMerchtSbfjUknoList = function (params, callback) {// 查询所有供商编码
    api.post('/retailer/door/mercht/sbfj/ukno/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 新增编码
exports.saveMerchtSbfjUkno = function (params, callback) {// 新增编码
    api.post('/retailer/door/mercht/sbfj/ukno/save/do')
    .data(params)
    .done(callback)
    .go();
};
// 上传编码
exports.doMerchtSbfjUknoImport = function (params, callback) {// 新增编码
    api.post('/retailer/door/mercht/sbfj/ukno/import/do')
    .data(params)
    .done(callback)
    .go();
};


exports.saveMerchtSbfjUknoParamsForExport = function (params, callback) {
    api.post('/retailer/door/ukno/params/for/export/url')
    .data(params)
    .done(callback)
    .go();
};
exports.saveMerchtSbfjUknoModelForExport = function (params, callback) {
    api.post('/retailer/door/ukno/model/for/export/url')
    .data(params)
    .done(callback)
    .go();
};
// 作废商品标识码
exports.doMerchtSbfjUKnoInvalid = function (params, callback) {
    api.post('/retailer/door/mercht/sbfj/ukno/invalid/do')
    .data(params)
    .done(callback)
    .go();
};
// 删除商品标识码
exports.doMerchtSbfjUKnoDelete = function (params, callback) {
    api.post('/retailer/door/mercht/sbfj/ukno/delete/do')
    .data(params)
    .done(callback)
    .go();
};
// 商品标识码-关联买家/解除买家
exports.updateMerchtSbfjUknoRetailerInfo = function (params, callback) {
    api.post('/retailer/door/mercht/sbfj/ukno/retailer/update/do')
    .data(params)
    .done(callback)
    .go();
};
// 查询商品标识码使用记录
exports.getMerchtSbfjUknoRecList = function (params, callback) {
    api.post('/retailer/door/mercht/sbfj/ukno/rec/list/get')
    .data(params)
    .done(callback)
    .go();
};
//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/doorDeliv.js
// module id = 392
// module chunks = 0